import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-container',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-container{display:block;margin:0 20px}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-container]': 'true'
  }
})
export class ContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
